<template>
    <span v-if="value === null || value === undefined" class="text-gray-400"
        >—</span
    >
    <span
        v-else-if="typeof value === 'boolean'"
        class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium"
        :class="
            value ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-500'
        "
    >
        {{ value ? t("vue.ai_slash_yes") : t("vue.ai_slash_no") }}
    </span>
    <span
        v-else-if="typeof value === 'number'"
        class="tabular-nums text-gray-800"
        >{{ value }}</span
    >
    <span v-else class="break-words text-gray-800">{{ value }}</span>
</template>

<script lang="ts" setup>
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

defineProps<{ value: unknown }>();
</script>
